import { useTranslation } from 'react-i18next';

interface NarrativeEmptyStateProps {
  filterType?: 'today' | 'week' | 'custom';
}

export function NarrativeEmptyState({ filterType }: NarrativeEmptyStateProps) {
  const { t } = useTranslation();

  // Determine message based on filter type
  const getMessage = () => {
    if (filterType === 'today') {
      return t('narrative.empty.today');
    }
    if (filterType === 'week') {
      return t('narrative.empty.week');
    }
    // Default message for custom
    return t('narrative.empty.custom');
  };

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
      <div className="flex flex-col items-center gap-2 font-['Inter']">
        <p className="text-foreground text-center font-['Inter'] text-[14px] leading-[160%] font-semibold tracking-[0%]">
          {t('narrative.empty.title')}
        </p>
        <div className="flex max-w-[260px] flex-col items-center gap-2">
          <p className="text-foreground text-center font-['Inter'] text-[12px] leading-[170%] font-normal tracking-[0%]">
            {getMessage()}
          </p>
        </div>
      </div>
    </div>
  );
}
